export default "__VITE_ASSET__Cf02gj4q__"